export default __webpack_public_path__ + "static/media/6.c017129f.mp3";